import { render, staticRenderFns } from "./ChartsmixBar.vue?vue&type=template&id=606b64c8&"
import script from "./ChartsmixBar.vue?vue&type=script&lang=js&"
export * from "./ChartsmixBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports